import { Link, useMatch, useResolvedPath } from "react-router-dom"

export default function Navbar() {

  return (
    <nav className="nav">
      <ul>
        <CustomLink to="/">
          <span className="icon-homeDefault"></span>
          <p className="yekan caption-1">خانه</p>
        </CustomLink>
        <CustomLink to="/cards">
          <span className="icon-iconsearch"></span>
          <p className="yekan caption-1">غذاها</p>
        </CustomLink>
         <CustomLink to="/groups" end={false}>
          <span className="icon-iconteam"></span>
          <p className="yekan caption-1">گروه‌ها</p>
        </CustomLink>
        <CustomLink to="/calendar">
          <span className="icon-calendarDefault"></span>
          <p className="yekan caption-1">تقویم</p>
        </CustomLink>
        <CustomLink to="/grocery">
          <span className="icon-iconshopping"></span>
          <p className="yekan caption-1">خرید</p>
        </CustomLink>
       
      </ul>
    </nav>
  )
}

function CustomLink({ to, end = true, children, ...props }) {
  const resolvedPath = useResolvedPath(to)
  const isActive = useMatch({ path: resolvedPath.pathname, end })

  return (
    <li className={isActive ? "active" : ""}>
      <Link to={to} {...props}>
        {children}
      </Link>
    </li>
  )
}
